// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ejNz2","title":"styles_title__35FAg"};